// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__rhozK","icon_not":"Icon_icon_not__BRrDE","container":"Icon_container__XkyUO"};